module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('CreativeImp', {
    staticClass: "contentWrapper",
    attrs: {
      "campaignType": _vm.campaignType,
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "viewData": _vm.viewData.data,
      "tab": "creative"
    }
  }), _vm._v(" "), (!_vm.isInterPlay) ? _c('dateTable', {
    attrs: {
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "campaginDaysData": _vm.viewData.daysData,
      "dataInfo": _vm.viewData.data,
      "tab": "creative"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInterPlay) ? _c('InterPlayCrBottom', {
    attrs: {
      "campaignData": _vm.viewData.data,
      "campaginDaysData": _vm.viewData.daysData,
      "campaignType": _vm.campaignType,
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "isExcel": _vm.isExcel
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38b38a64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/creative/CreativeMain.vue
// module id = 842
// module chunks = 1